import { ISortItem } from './ISortItem';
import {
  BuyingActivitySortItemType,
  MarketplaceSortItemType,
  PurchaseReceiptSortItemType,
  SearchSortItemType
} from '../types/SortItemTypes';
import { SortDirectionType } from '../types/SortDirectionType';
import { ITranslatorAccountSettings, LanguageType } from '@tc/translator';
import { IAccountSettingsConfiguration } from '@tc/account-settings';
import { DefaultConfiguration } from '../../site/configuration/DefaultConfiguration';

export const DefaultPageSize = 50;

export class AccountSettings extends DefaultConfiguration {

  // Page Sizing
  AuctionPageSize = DefaultPageSize;
  MyAuctionsPageSize = DefaultPageSize;
  MyBackordersPageSize = DefaultPageSize;
  PurchaseReceiptPageSize = DefaultPageSize;
  BuyingActivityPageSize = DefaultPageSize;
  PendingAuctionsPageSize = DefaultPageSize;
  ActiveAuctionsPageSize = DefaultPageSize;
  InEscrowPageSize = DefaultPageSize;
  SellingHistoryPageSize = DefaultPageSize;
  DomainDetailBidHistoryPageSize = DefaultPageSize;
  BuyingDiscountClubPageSize = DefaultPageSize;
  ApiClientsPageSize = DefaultPageSize;
  // Sorting
  AuctionSorts: ISortItem[] = [
    { field: SearchSortItemType.SortPriority, direction: SortDirectionType.Ascending },
    { field: SearchSortItemType.HighBid, direction: SortDirectionType.Descending }
  ];
  MyAuctionSorts: ISortItem[] = [{ field: SearchSortItemType.HighBid, direction: SortDirectionType.Descending }];
  MyBackorderSorts: ISortItem[] = [{ field: SearchSortItemType.MaxBid, direction: SortDirectionType.Ascending }];
  MyDiscountClubSorts: ISortItem[] = [{ field: SearchSortItemType.MaxBid, direction: SortDirectionType.Ascending }];
  PendingAuctionSorts: ISortItem[] = [{ field: MarketplaceSortItemType.Domain, direction: SortDirectionType.Ascending }];
  ActiveAuctionSorts: ISortItem[] = [{ field: MarketplaceSortItemType.Date, direction: SortDirectionType.Descending }];
  InEscrowSorts: ISortItem[] = [{ field: MarketplaceSortItemType.Date, direction: SortDirectionType.Descending }];
  SellingHistorySorts: ISortItem[] = [{ field: MarketplaceSortItemType.Date, direction: SortDirectionType.Descending }];
  PurchaseReceiptSorts: ISortItem[] = [{ field: PurchaseReceiptSortItemType.Date, direction: SortDirectionType.Descending }];
  BuyingActivitySorts: ISortItem[] = [{ field: BuyingActivitySortItemType.Date, direction: SortDirectionType.Descending }];

  // Other
  DropCatchBackorderEmailNotifications = false;
  DropCatchAuctionEmailNotifications = false;
  DiscountClubTermsAndConditions = false;
  DisplayLanguage = LanguageType.NoLanguage;
  InvoiceAddress = '';
}
